import React from "react";
import { Box, Text, type BoxProps } from "@chakra-ui/react";
import { DemoForm } from "components/demo-form";

export function SidebarDemo(props: BoxProps) {
  return (
    <Box background="brand.backgroundSecondary.light" borderRadius="base" p="small" {...props}>
      <Text mb="smaller" textStyle="body3" fontWeight="semibold">
        Book a demo
      </Text>

      <DemoForm />
    </Box>
  );
}
